import React from 'react';
import './styles.css';

/**
 * 按鈕組件
 * 用於顯示各種類型的按鈕
 * 
 * @param {Object} props - 組件屬性
 * @param {string} props.type - 按鈕類型 (button, submit, reset)
 * @param {string} props.variant - 按鈕變體 (primary, secondary, danger, success, outline)
 * @param {string} props.size - 按鈕大小 (small, medium, large)
 * @param {boolean} props.disabled - 是否禁用
 * @param {boolean} props.fullWidth - 是否全寬
 * @param {Function} props.onClick - 點擊回調函數
 * @param {React.ReactNode} props.children - 按鈕內容
 * @param {string} props.className - 額外的CSS類名
 * @returns {JSX.Element} 按鈕組件
 */
function Button({
    type = 'button',
    variant = 'primary',
    size = 'medium',
    disabled = false,
    fullWidth = false,
    onClick,
    children,
    className = '',
    ...rest
}) {
    // 構建按鈕類名
    const buttonClasses = [
        'button',
        `button-${variant}`,
        `button-${size}`,
        fullWidth ? 'button-block' : '',
        className
    ].filter(Boolean).join(' ');

    return (
        <button
            type={type}
            className={buttonClasses}
            disabled={disabled}
            onClick={onClick}
            {...rest}
        >
            {children}
        </button>
    );
}

export default Button; 